export default "<div class=\"not_found\">{{ text }}</div>\n"